// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-not-found {
  margin: auto;
  margin-top: 10%;
  width: 50%;
  height: 50%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/page-not-found-page/page-not-found-page.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AACJ","sourcesContent":[".center-not-found {\n    margin: auto;\n    margin-top: 10%;\n    width: 50%;\n    height: 50%;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
